/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBracketsContain = createReactComponent("brackets-contain", "IconBracketsContain", [
  ["path", { d: "M7 4h-4v16h4", key: "svg-0" }],
  ["path", { d: "M17 4h4v16h-4", key: "svg-1" }],
  ["path", { d: "M8 16h.01", key: "svg-2" }],
  ["path", { d: "M12 16h.01", key: "svg-3" }],
  ["path", { d: "M16 16h.01", key: "svg-4" }]
]);

export { IconBracketsContain as default };
//# sourceMappingURL=IconBracketsContain.js.map
